export const MeasurementAggregators = {
  MIN: "min",
  MAX: "max",
  MEAN: "mean",
  COUNT: "count",
  SUM: "sum",
  AVERAGE: "avg",
} as const;
export type MeasurementAggregatorsType =
  (typeof MeasurementAggregators)[keyof typeof MeasurementAggregators];
